<mat-toolbar color="primary" class="selector-toolbar" [ngClass]="{ 'blocked': loading.getValue() }">

    <mat-toolbar-row *ngIf="disabled" class="toolbar-view disabled">
        <span>{{ title }} ({{ selectedNodesNumber }})</span>
    </mat-toolbar-row>

    <mat-toolbar-row *ngIf="!disabled" [ngClass]="{ 'toolbar-view': status === 'view' }">

        <div class="toolbar-title">{{ title }} ({{ selectedNodesNumber }})</div>

        <!-- Extra buttons -->
        <div class="cp-content-extra">
            <ng-content select="[extra-buttons-before]"></ng-content>
        </div>

        <div class="input-search-icons">
            <mat-icon>search</mat-icon>
        </div>

        <ng-container *ngIf="inputSearchText; else defaultInputSearchText">
            <input matInput placeholder="{{ inputSearchText }}" class="themed-input" autocomplete="off"
                (input)="applyFilter($event.target.value)" [(ngModel)]="treeFilterHandler.filterValue"
                (focus)="onFocus()" (blur)="onBlur()" />
        </ng-container>

        <ng-template #defaultInputSearchText>
            <input matInput placeholder="{{ 'se-ui-selector-web_input_search' | translate }}" class="themed-input"
                autocomplete="off" (input)="applyFilter($event.target.value)"
                [(ngModel)]="treeFilterHandler.filterValue" (focus)="onFocus()" (blur)="onBlur()" />
        </ng-template>

        <div class="input-search-icons cursor" *ngIf="treeFilterHandler.filterValue"
            (click)="treeFilterHandler.emptyFilter($event, status)">
            <mat-icon>close</mat-icon>
        </div>

        <div class="loading-container">
            <mat-icon aria-hidden="false" aria-label="Loading" class="rotating" [ngClass]="{ hidden: !loading.value}">
                autorenew</mat-icon>
        </div>


        <ng-container *ngIf="status !== 'view'">

            <div class="expand-container">
                <mat-icon matTooltip="{{ 'se-ui-selector-web_collapse_all' | translate }}"
                    (click)="treeCommandsHandler.collapseAll()">expand_less</mat-icon>
                <mat-icon matTooltip="{{ 'se-ui-selector-web_expand_all' | translate }}"
                    (click)="treeCommandsHandler.expandAll()">expand_more</mat-icon>
            </div>

            <button *ngIf="selectedNodesNumber" mat-icon-button
                matTooltip="{{'se-ui-selector-web_deselect_all' | translate}}" matTooltipPosition="right"
                (click)="treeCommandsHandler.unCheckAll()">
                <mat-icon>library_add_check</mat-icon>
            </button>

            <button *ngIf="!selectedNodesNumber" [disabled]="true" mat-icon-button
                matTooltip="{{ 'se-ui-selector-web_select_all' | translate}}" matTooltipPosition="right"
                (click)="treeCommandsHandler.checkAll()" class="filter_all">
                <mat-icon>filter_none</mat-icon>
            </button>

        </ng-container>
    </mat-toolbar-row>
</mat-toolbar>
